import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, Link } from "react-router-dom";
import useMemLogout from "../../../hooks/useMemLogout";
import MemberContext from "../../../context/MemberProvider";
import { format, sub } from "date-fns";

const dateTime = `${format(new Date(), 'dd-MM-yyyy\t\t\tHH:mm:ss')}`;
const date = new Date();


const MemberHeader = () => {

  const [date, setDate] = useState(Date().toLocaleString());
  const { mem } = useContext(MemberContext)

  const navigate = useNavigate();
  const logout = useMemLogout();

  const logOut = async () => {
    await logout();
    navigate('/member_login');
  }

  return (
    <header className="main-header">
      <a className="logo" href="/dashboard">
        <span className="logo-mini">
        </span>
        <div className="proforum-logo">
          <img src="/images/logos/proforum.jpg" alt="Proforum" />
          <span className="logo-lg"><strong> NDC PROFORUM</strong></span>
        </div>
      </a>
      <nav className="navbar navbar-static-top" role="navigation">
        <a className="sidebar-toggle" href="#" role="button" data-toggle="offcanvas">
          <span className="sr-only"></span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>&nbsp;&nbsp;&nbsp;&nbsp;
          <span className="logo-mini">
            <b>PROFORUM MMS - Member Portal</b>
          </span>
        </a>
        <div className="navbar-custom-menu">
          <ul className="nav navbar-nav">
            <li className="dropdown user user-menu">
              <a className="dropdown-toggle" href="#" data-toggle="dropdown">
                <span className="hidden-xs">
                  <span><i className="fas fa-user"></i> {mem.user} ({mem.user_role})</span><span></span>
                </span>
              </a>
            </li>
            <li className="user-footer">
              <Link to='/logout' className="logout" data-method="delete" data-placement="bottom" data-toggle="tooltip" onClick={logOut} rel="nofollow" title="Logout">
                <span className="hidden-xs"><i className="fa fa-sign-out"></i> Logout</span>
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  )
}

export default MemberHeader
